import {Component, inject} from '@angular/core';
import {RouterLink} from "@angular/router";
import {NgClass, NgOptimizedImage} from "@angular/common";
import {HeaderService} from "./services/header.service";
import {toSignal} from "@angular/core/rxjs-interop";
import {HeaderThemeEnum} from "./enum/theme.enum";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {SideMenuComponent} from "../side-menu/side-menu.component";
import {childContainerAnimate} from "../../common/animations/animations";
import {HeaderMenuComponent} from "./components/header-menu/header-menu.component";

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [
    RouterLink,
    NgOptimizedImage,
    NgClass,
    MatIcon,
    MatIconButton,
    SideMenuComponent,
    HeaderMenuComponent
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  animations: [childContainerAnimate]
})
export class HeaderComponent {

  protected headerService = inject(HeaderService);

  headerTheme = toSignal(this.headerService.getHeaderTheme(), {initialValue: HeaderThemeEnum.black});
  menuToggleState = toSignal(this.headerService.getMenuToggleActive());

  toggleMenu() {
    this.headerService.setMenuToggleActive();
  }

}
